@if (app?.icon | isIconCustom) {
    <div
        class="card-logo"
        [ngStyle]="{ 'background-image': 'url(' + app?.icon + ')' }"
        [ngClass]="{
            'card-disabled-logo': !app?.url && showDisabledState,
            'app-icon-lg': size === AppIconSize.LARGE,
            'app-icon-sm': size === AppIconSize.SMALL
        }"
    ></div>
} @else {
    <div
        class="card-logo-icon {{ app?.icon }}"
        [ngClass]="{
            'card-disabled-logo': !app?.url && showDisabledState,
            'app-icon-lg': size === AppIconSize.LARGE,
            'app-icon-sm': size === AppIconSize.SMALL
        }"
        [style.background-color]="themeColor"
    >
        @if (!app?.icon) {
            <div class="card-logo-ico-text">{{ app?.name | appInitials }}</div>
        }
    </div>
}
